export default __webpack_public_path__ + "static/media/homepage_module_comments_stats.ad9046ed.png";